import { apiClient } from '../utils/ApiClient'
import {
  CountryDetail,
  GlobalAppData,
  IncludeExcludeLinksResponse,
  TranslationConfig,
  TranslationConfigUpdateForm,
  TranslationLanguages
} from '../utils/Interfaces'

/**
 * TODO: Modify this in future when we use this for
 * more than just PDB-specific link references
 */
export enum EnrichmentConfigUrlType {
  Product = 'product',
  Brand = 'brand',
  Reference = 'reference'
}

export enum EnrichmentConfigUrlMode {
  Include = 'include',
  Exclude = 'exclude'
}

export interface EnrichmentConfigUrlModel {
  id?: string
  url?: string
  url_type: EnrichmentConfigUrlType
  url_mode: EnrichmentConfigUrlMode
  product_database_id: string
  attribute_field_id: string
  deleted?: boolean
}

export interface CreateEnrichmentConfigProductDatabaseUrl {
  url_type: EnrichmentConfigUrlType.Product
  url_mode: EnrichmentConfigUrlMode
  product_database_id: string
  attribute_field_id: string
}

export const getGlobalAppData = async (): Promise<GlobalAppData> => {
  return await apiClient
    .get<GlobalAppData>('/global_app_data')
    .then((resp) => resp.data)
}
export const apiGetCountryList = async (): Promise<CountryDetail[]> => {
  const resp = await apiClient.get('/country-list')
  return resp.data
}
export const fetchAvailableTranslationLanguages = async (): Promise<TranslationLanguages> => {
  const resp = await apiClient.get<TranslationLanguages>(
    '/translation_languages'
  )
  return resp.data
}
export const fetchTranslationConfig = () => {
  return apiClient
    .get<TranslationConfig>('/translation_config')
    .then((resp) => resp.data)
}
export const handleTranslationConfigChange = (
  updateForm: TranslationConfigUpdateForm
) => {
  return apiClient.put<void>('/translation_config', null, {
    params: updateForm
  })
}

export const apiSaveWebEnrichmentIncludeExcludeLinks = async ({
  includeLinks,
  excludeLinks
}: {
  includeLinks: string[]
  excludeLinks: string[]
}): Promise<void> => {
  return apiClient.post(`/organization/save-include-exclude-links`, {
    include_links: includeLinks,
    exclude_links: excludeLinks
  })
}

export const apiGetIncludeLinksFromFile = async (
  file: File
): Promise<string[]> => {
  const formData = new FormData()
  formData.append('file', file)

  const response = await apiClient.post(
    '/organization/add-include-links',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  return response.data
}

export const apiGetExcludeLinksFromFile = async (
  file: File
): Promise<string[]> => {
  const formData = new FormData()
  formData.append('file', file)

  const response = await apiClient.post(
    '/organization/add-exclude-links',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  return response.data
}

export const apiGetIncludeExcludeLinks = async (): Promise<IncludeExcludeLinksResponse> => {
  const response = await apiClient.get('/organization/include-exclude-links')
  return response.data
}

export async function apiGetProductDatabaseLinks(
  productDatabaseId: string
): Promise<EnrichmentConfigUrlModel[]> {
  const res = await apiClient.get<EnrichmentConfigUrlModel[]>(
    `/enrichment-config`,
    {
      params: { product_database_id: productDatabaseId }
    }
  )
  return res.data
}

export async function apiCreateEnrichmentConfigUrls(
  body: CreateEnrichmentConfigProductDatabaseUrl[]
): Promise<EnrichmentConfigUrlModel[]> {
  const res = await apiClient.post<EnrichmentConfigUrlModel[]>(
    `/enrichment-config`,
    body
  )
  return res.data
}

export async function apiRemoveProductDatabaseLinks(
  ids_to_delete: string[]
): Promise<EnrichmentConfigUrlModel[]> {
  const res = await apiClient.post<EnrichmentConfigUrlModel[]>(
    `/enrichment-config/delete`,
    ids_to_delete
  )
  return res.data
}
